import * as _ from 'lodash';
import { FormatterEx } from 'slickgrid';

export interface MapValueFormatterOptions {
  mapping: Dictionary<string>;
}

export function mapvalue<T>(opts: MapValueFormatterOptions): FormatterEx<T> {
  const mapping = _.reduce(
    opts.mapping,
    (m, v, k) => {
      m[`${k}`] = v;
      return m;
    },
    {} as Dictionary<any>,
  );

  const fn: FormatterEx<T> = function mapvalueFormatter(
    row,
    cell,
    value,
    columnDef,
    data,
  ) {
    return _.get(mapping, value, value);
  };

  fn.filterFormattedData = true;

  return fn;
}
